import {Component} from '@angular/core';
import {JOB_OPTIONS, JOB_STATUS, JOB_STATUS_OPTIONS} from '../constants';
import {HeaderDataService} from "../../services/header_data.service";
import {SharedPipesModule} from "../../shared/modules/shared-pipes.module";

import {COMMON_FORM_IMPORTS} from "../../shared/import-groups/Common";
import {JobsTableComponent} from "../jobs-table/jobs-table.component";
import {DateTimePickerComponent} from "../../date-time/date-time-picker/date-time-picker.component";

@Component({
    selector: 'job-list',
    templateUrl: './job-list.component.html',
    styleUrls: ['./job-list.component.scss'],
    imports: [
        COMMON_FORM_IMPORTS,
        SharedPipesModule,
        JobsTableComponent,
        DateTimePickerComponent
    ]
})
export class JobListComponent {
    scope_job_type: string;
    scope_job_status: string;
    created_date: Date;
    updated_date: Date;
    job_options = JOB_OPTIONS;
    status_options = JOB_STATUS_OPTIONS;

    ROUTES: { [job_type: string]: string } = {
        series_correction: 'series-correction'
    };

    constructor(private headerData: HeaderDataService) {
        this.buildHeader();
    }

    buildHeader() {
        this.headerData.title = 'Background Jobs';
        this.headerData.show_dtp = true;
    }
}
